import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Banner, Process, Skills, FAQs, Clients } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <WhyUs />
        <Process />
        <Skills />
        <FAQs />
        <Testimonials />
        <Team />
        <Banner />
        <Clients />

      </section>

    </>
  );
}

export default AboutUs;